export const GET_GPS_REQUEST = "GET_GPS_REQUEST";
export const GET_GPS_SUCCESS = "GET_GPS_SUCCESS";
export const GET_GPS_FAILURE = "GET_GPS_FAILURE";

export const GET_GPS_STATUSES_REQUEST = "GET_GPS_STATUSES_REQUEST";
export const GET_GPS_STATUSES_SUCCESS = "GET_GPS_STATUSES_SUCCESS";
export const GET_GPS_STATUSES_FAILURE = "GET_GPS_STATUSES_FAILURE";

export const GET_GPS_SUBSTATUS_REQUEST = "GET_GPS_SUBSTATUS_REQUEST";
export const GET_GPS_SUBSTATUS_SUCCESS = "GET_GPS_SUBSTATUS_SUCCESS";
export const GET_GPS_SUBSTATUS_FAILURE = "GET_GPS_SUBSTATUS_FAILURE";

export const GET_HISTORY_GPS_REQUEST = "GET_HISTORY_GPS_REQUEST";
export const GET_HISTORY_GPS_SUCCESS = "GET_HISTORY_GPS_SUCCESS";
export const GET_HISTORY_GPS_FAILURE = "GET_HISTORY_GPS_FAILURE";

export const SUBMIT_GPS_DEVICES_VALIDATE_BATCH_REQUEST = "SUBMIT_GPS_DEVICES_VALIDATE_BATCH_REQUEST";
export const SUBMIT_GPS_DEVICES_VALIDATE_BATCH_SUCCESS = "SUBMIT_GPS_DEVICES_VALIDATE_BATCH_SUCCESS";
export const SUBMIT_GPS_DEVICES_VALIDATE_BATCH_FAILURE = "SUBMIT_GPS_DEVICES_VALIDATE_BATCH_FAILURE";
export const CLEAR_VALIDATED_GPS_DEVICES = "CLEAR_VALIDATED_GPS_DEVICES";

export const SET_STATE_GPS = "SET_STATE_GPS";

export const SET_GPS_SELECTED = "SET_GPS_SELECTED";

export const SUBMIT_GPS_REQUEST = "SUBMIT_GPS_REQUEST";
export const SUBMIT_GPS_SUCCESS = "SUBMIT_GPS_SUCCESS";
export const SUBMIT_GPS_FAILURE = "SUBMIT_GPS_FAILURE";

export const PATCH_GPS_DEVICES_REQUEST = "PATCH_GPS_DEVICES_REQUEST";
export const PATCH_GPS_DEVICES_SUCCESS = "PATCH_GPS_DEVICES_SUCCESS";
export const PATCH_GPS_DEVICES_FAILURE = "PATCH_GPS_DEVICES_FAILURE";

export const UPDATE_GPS_DEVICE_REQUEST = "UPDATE_GPS_DEVICE_REQUEST";
export const UPDATE_GPS_DEVICE_SUCCESS = "UPDATE_GPS_DEVICE_SUCCESS";
export const UPDATE_GPS_DEVICE_FAILURE = "UPDATE_GPS_DEVICE_FAILURE";

export const SUBMIT_GPS_STATUSES_REQUEST = "SUBMIT_GPS_STATUSES_REQUEST";
export const SUBMIT_GPS_STATUSES_SUCCESS = "SUBMIT_GPS_STATUSES_SUCCESS";
export const SUBMIT_GPS_STATUSES_FAILURE = "SUBMIT_GPS_STATUSES_FAILURE";

export const SUBMIT_GPS_BATCH_REQUEST = "SUBMIT_GPS_BATCH_REQUEST";
export const SUBMIT_GPS_BATCH_SUCCESS = "SUBMIT_GPS_BATCH_SUCCESS";
export const SUBMIT_GPS_BATCH_FAILURE = "SUBMIT_GPS_BATCH_FAILURE";

export const UNSUBSCRIBE_REQUEST = "UNSUBSCRIBE_REQUEST";
export const UNSUBSCRIBE_SUCCESS = "UNSUBSCRIBE_SUCCESS";
export const UNSUBSCRIBE_FAILURE = "UNSUBSCRIBE_FAILURE";
export const CLEAN_UNSUBSCRIBE = "CLEAN_UNSUBSCRIBE";

export const UNLOCK_GPS_REQUEST = "UNLOCK_GPS_REQUEST";
export const UNLOCK_GPS_SUCCESS = "UNLOCK_GPS_SUCCESS";
export const UNLOCK_GPS_FAILURE = "UNLOCK_GPS_FAILURE";

export const GET_EXPORT_GPS_REQUEST = "GET_EXPORT_GPS_REQUEST";
export const GET_EXPORT_GPS_SUCCESS = "GET_EXPORT_GPS_SUCCESS";
export const GET_EXPORT_GPS_FAILURE = "GET_EXPORT_GPS_FAILURE";

export const CLOSE_PING_EVENT_EXPORT_GPS = "CLOSE_PING_EVENT_EXPORT_GPS";

export const unlockGpsFailure = err => ({
    type: UNLOCK_GPS_FAILURE,
    error: err
})

export const unlockGpsSuccess = status => ({
    type: UNLOCK_GPS_SUCCESS,
    payload: {
        status
    }
});

export const unlockGpsRequest = (gps_id) => ({
    type: UNLOCK_GPS_REQUEST,
    payload: {
        gps_id
    }
});

export const getGpsDevicesRequest = (filters = {}) => ({
    type: GET_GPS_REQUEST,
    payload: {
        filters,
        page: filters.page || 1 
    }
});

export const getGpsDevicesSuccess = (gps_devices, total, page = 1) => ({
    type: GET_GPS_SUCCESS,
    payload: {
        gps_devices,
        total,
        page 
    }
});

export const getGpsDevicesFailure = err => ({
    type: GET_GPS_FAILURE,
    error: err
});

export const patchGpsDevicesRequest = (gpsDevicesArray) => ({
    type: PATCH_GPS_DEVICES_REQUEST,
    payload: {
        gpsDevicesArray
    }
});

export const patchGpsDevicesSuccess = () => ({
    type: PATCH_GPS_DEVICES_SUCCESS
});

export const patchGpsDevicesFailure = (err) => ({
    type: PATCH_GPS_DEVICES_FAILURE,
    error: err
});

export const updateGpsDeviceRequest = (gpsId, updates) => ({
    type: UPDATE_GPS_DEVICE_REQUEST,
    payload: { gpsId, updates }
});

export const updateGpsDeviceSuccess = (gpsDevice) => ({
    type: UPDATE_GPS_DEVICE_SUCCESS,
    payload: { gpsDevice }
});

export const updateGpsDeviceFailure = (error) => ({
    type: UPDATE_GPS_DEVICE_FAILURE,
    error
});

export const getGpsStatusesRequest = (filters = {}) => ({
    type: GET_GPS_STATUSES_REQUEST,
    payload: {
        filters
    }
});

export const getGpsStatusesSuccess = (statuses, total) => ({
    type: GET_GPS_STATUSES_SUCCESS,
    payload: {
        statuses
    }
});

export const getGpsStatusesFailure = err => ({
    type: GET_GPS_STATUSES_FAILURE,
    error: err
});

export const getGpsSubstatusRequest = (filters = {}) => ({
    type: GET_GPS_SUBSTATUS_REQUEST,
    payload: {
        filters
    }
});

export const getGpsSubstatusSuccess = (substatus, total) => ({
    type: GET_GPS_SUBSTATUS_SUCCESS,
    payload: {
        substatus
    }
});

export const getGpsSubstatusFailure = err => ({
    type: GET_GPS_SUBSTATUS_FAILURE,
    error: err
});

export const getHistoryGpsRequest = (filters = {}) => ({
    type: GET_HISTORY_GPS_REQUEST,
    payload: {
        filters
    }
});

export const getHistoryGpsSuccess = (history, total) => ({
    type: GET_HISTORY_GPS_SUCCESS,
    payload: {
        history
    }
});

export const getHistoryGpsFailure = err => ({
    type: GET_HISTORY_GPS_FAILURE,
    error: err
});

export const setStateGps = (payload = {}) => ({
    type: SET_STATE_GPS,
    payload: {
        ...payload
    }
});

export const setGpsSelected = (gps_device = {}) => ({
    type: SET_GPS_SELECTED,
    payload: {
        gps_device
    }
});

export const submitGpsDevicesRequest = gps_device => ({
    type: SUBMIT_GPS_REQUEST,
    payload: {
        gps_device
    }
});

export const submitGpsDevicesSuccess = gps_device => ({
    type: SUBMIT_GPS_SUCCESS,
    payload: {
        gps_device
    }
});

export const submitGpsDevicesFailure = err => ({
    type: SUBMIT_GPS_FAILURE,
    error: err
});

export const submitGpsDevicesStatusesRequest = status => ({
    type: SUBMIT_GPS_STATUSES_REQUEST,
    payload: {
        status
    }
});

export const submitGpsDevicesStatusesSuccess = status => ({
    type: SUBMIT_GPS_STATUSES_SUCCESS,
    payload: {
        status
    }
});

export const submitGpsDevicesStatusesFailure = err => ({
    type: SUBMIT_GPS_STATUSES_FAILURE,
    error: err
});

export const submitGpsBatchRequest = gps_devices => ({
    type: SUBMIT_GPS_BATCH_REQUEST,
    payload: {
        gps_devices
    }
});

export const submitGpsBatchSuccess = gps_devices => ({
    type: SUBMIT_GPS_BATCH_SUCCESS,
    payload: {
        gps_devices
    }
});

export const submitGpsBatchFailure = err => ({
    type: SUBMIT_GPS_BATCH_FAILURE,
    error: err
});

export const submitGpsDevicesValidateBatchRequest = gps_device => ({
    type: SUBMIT_GPS_DEVICES_VALIDATE_BATCH_REQUEST,
    payload: {
        gps_device
    }
});

export const submitGpsDevicesValidateBatchSuccess = validations => ({
    type: SUBMIT_GPS_DEVICES_VALIDATE_BATCH_SUCCESS,
    payload: {
        validations
    }
});

export const submitGpsDevicesValidateBatchFailure = err => ({
    type: SUBMIT_GPS_DEVICES_VALIDATE_BATCH_FAILURE,
    error: err
});

export const clearValidatedGpsDevices = () => ({ type: CLEAR_VALIDATED_GPS_DEVICES })

export const getExportGpsRequest = (filters) => ({
    type: GET_EXPORT_GPS_REQUEST,
    payload: {
        filters
    }
});

export const getExportGpsSuccess = (fileName) => ({
    type: GET_EXPORT_GPS_SUCCESS,
    payload: {
        fileName
    }
});

export const getExportGpsFailure = () => ({
    type: GET_EXPORT_GPS_FAILURE,
    
});


export const closePingEventExportGps = () => ({
    type: CLOSE_PING_EVENT_EXPORT_GPS,
});

export const unsubscribeRequest = (gps_devices) => ({
    type: UNSUBSCRIBE_REQUEST,
    payload: {
        gps_devices
    }
});

export const unsubscribeSuccess = (errors) => ({
    type: UNSUBSCRIBE_SUCCESS,
    payload: {
        errors
    }
});

export const unsubscribeFailure = (error) => ({
    type: UNSUBSCRIBE_FAILURE,
    payload: {
        error
    }
});

export const cleanUnsubscribe = () => ({
    type: CLEAN_UNSUBSCRIBE
});